// biome-ignore lint/style/useFilenamingConvention: TanStack Router splat route
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import {
  buildOrgProjectPath,
  OrgProjectRouteError,
} from "@/lib/org-project-context/constants";
import { OrgProjectErrorFallback } from "@/lib/org-project-context/error-fallbacks";
import { resolveDashboardOrgProjectRoute } from "@/lib/org-project-context/hooks";

export const Route = createFileRoute("/_authenticated/$")({
  beforeLoad: async ({ context, params, location }) => {
    const splatPath = params._splat ?? "";

    // If the path already starts with "orgs/", it means TanStack Router
    // couldn't find a leaf route after resolving the org/project layout
    // and fell back to this splat. Show a 404 instead of redirecting again.
    if (splatPath.startsWith("orgs/")) {
      throw notFound();
    }

    const result = await resolveDashboardOrgProjectRoute(context.queryClient);

    if (result.outcome === "redirect") {
      const suffix = splatPath.startsWith("/") ? splatPath : `/${splatPath}`;
      const fullPath = buildOrgProjectPath(suffix, {
        organizationId: result.organizationId,
        projectId: result.projectId,
      });

      throw redirect({
        href: `${fullPath}${location.searchStr}${location.hash}`,
      });
    }

    throw new OrgProjectRouteError(result);
  },
  errorComponent: OrgProjectErrorFallback,
});
